import {
    Box,
    Button,
    Menu,
    MenuButton,
    MenuItemOption,
    MenuList,
    MenuOptionGroup
} from '@chakra-ui/react'

import React from 'react'

import { Icon, Pagination } from 'components/atoms'
import { LimitPaginationProps } from './interfaces'

const LimitPagination: React.FC<LimitPaginationProps> = ({
    pagination,
    loading,
    onChangePage,
    onChangeLimit
}) => {
    const limits = ['5', '10', '20', '30', '40', '50']

    const handlePage = (page: number) => onChangePage && onChangePage(page)
    const handleLimit = (limit: string) =>
        onChangeLimit && onChangeLimit(+limit)

    return (
        <>
            {pagination && loading && (
                <Box
                    bgColor="white"
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                    px="15px"
                    py="19px"
                    borderBottomRadius="8px"
                >
                    <Menu matchWidth>
                        {({ isOpen }) => (
                            <>
                                <MenuButton
                                    data-testid="pagination-button-limit"
                                    as={Button}
                                    colorScheme="off-white"
                                    color="inherit"
                                    size="md"
                                    shadow="md"
                                    gap={2}
                                    rightIcon={
                                        <Icon
                                            name={
                                                isOpen
                                                    ? 'chevron-up'
                                                    : 'chevron-down'
                                            }
                                        />
                                    }
                                >
                                    {pagination.limit}
                                </MenuButton>

                                <MenuList
                                    data-testid="pagination-limit-list"
                                    border={0}
                                    shadow="md"
                                    minW="inherit"
                                >
                                    <MenuOptionGroup
                                        data-testid="pagination-group"
                                        type="radio"
                                        border={0}
                                        shadow="md"
                                        defaultValue="10"
                                        onChange={value =>
                                            handleLimit(value as string)
                                        }
                                    >
                                        {limits.map(limit => (
                                            <MenuItemOption
                                                data-testid={`pagination-limit-${limit}`}
                                                key={`pagination-limit-${limit}`}
                                                value={limit}
                                            >
                                                {limit}
                                            </MenuItemOption>
                                        ))}
                                    </MenuOptionGroup>
                                </MenuList>
                            </>
                        )}
                    </Menu>
                    {pagination.totalPages && pagination.page && (
                        <Pagination
                            pages={pagination.totalPages}
                            currentPage={pagination.page}
                            loading={!pagination.page}
                            changePage={handlePage}
                        />
                    )}
                </Box>
            )}
        </>
    )
}

export default LimitPagination
